import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getLink } from "../../dataProvider/links.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPencilAlt, faLock } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import TagManager from "react-gtm-module";
import { updateUser, reloadUser } from "../../actions/user";
import { error as logError } from "../../logger";

import emailIconV2 from "../../img/v2/user/email.png";
import downloadButton from "../../img/v2/home/upload/download-button.png";
import confirmationLogoV2 from "../../img/v2/payment/confirmationLogo.png";

import "../../scss/v2/payment.scss"

function Confirm(props) {
  const { t, i18n } = useTranslation();
  const [updateEmail, setUpdateEmail] = useState(false);
  const [email, setEmail] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!props.products.length) return;

    const purchaseKey = `purchase_tracked_${props.user.id}`;
    if (localStorage.getItem(purchaseKey)) return;

    const customerProduct = props.products.find((product) => product.id === props.user.products[0]);
    if (!customerProduct) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "purchase",
        ecommerce: {
          currencyCode: customerProduct.currency.toUpperCase(),
          purchase: {
            actionField: {
              id: props.user.id,
              revenue: customerProduct.amount / 100,
            },
            products: [
              {
                name: customerProduct.name,
                id: customerProduct.id,
                price: customerProduct.acquisitionAmount / 100,
                quantity: 1,
              },
            ],
          },
        },
      },
    });

    localStorage.setItem(purchaseKey, "true");
  }, [props.user, props.products]);

  const handleSubmit = () => {
    setError(false);
    return props
      .dispatch(updateUser({ id: props.user.id, email }))
      .then(() => {
        props.dispatch(reloadUser());
      })
      .then(() => {
        setUpdateEmail(false);
      })
      .catch((err) => {
        setError(true);
        logError(err);
      });
  };

  return (
    <>
      <div className="payment-confirmation container">
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <img className="img img-fluid payment-confirmation-image" src={confirmationLogoV2} alt={confirmationLogoV2} />
            <h1 className="payment-confirmation-title">
              {t("paymentConfirmation.title")}
            </h1>
            <div
              className="payment-confirmation-text"
              dangerouslySetInnerHTML={{
                __html: t("paymentConfirmation.text"),
              }}
            />
            <h2 className="payment-confirmation-title">
              {t("paymentConfirmation.card.title")}
            </h2>
          </div>
          <div className="col-12 col-lg-6 offset-lg-3">
            <div className="payment-confirmation-card">
              <p className="payment-confirmation-card-title">
                {t("paymentConfirmation.card.emailElement.title")}
              </p>
              {error ? (
                <div className="alert alert-danger mb-3">
                  {t(`contact.message.error.${error}`)}
                </div>
              ) : null}
              <div className="payment-confirmation-icon-text-container">
                <div className="payment-confirmation-icon-container">
                  <div className="payment-confirmation-icon-subcontainer">
                    <img className="img img-fluid" src={emailIconV2} alt={emailIconV2} />
                  </div>
                </div>
                {updateEmail ? (
                  <input
                    className="payment-confirmation-input"
                    placeholder={t("manage.account.placeholder.email")}
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                ) : (
                  <p className="payment-confirmation-text">
                    {props.user.email}
                  </p>
                )}
                <div className="payment-confirmation-editIcon-container">
                  {updateEmail ? (
                    <div
                      className="payment-confirmation-editIcon-subcontainer"
                      onClick={handleSubmit}
                    >
                      <FontAwesomeIcon icon={faCheck} />
                    </div>
                  ) : (
                    <div
                      className="payment-confirmation-editIcon-subcontainer"
                      onClick={() => setUpdateEmail(true)}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </div>
                  )}
                </div>
              </div>
              <p className="payment-confirmation-card-title">
                {t("manageAccount.topCard.passwordElement.title")}
              </p>
              <div className="payment-confirmation-icon-text-container">
                <div className="payment-confirmation-icon-container">
                  <div className="payment-confirmation-icon-subcontainer">
                    <FontAwesomeIcon icon={faLock} />
                  </div>
                </div>
                <p className="payment-confirmation-text">
                  {props.user.metadata.biblio.password}
                </p>
                <div className="payment-confirmation-editIcon-container">
                  <div className="payment-confirmation-editIcon-subcontainer">
                    <Link to={getLink("passwordChange", i18n.language)}>
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <Link to={getLink("cloud", i18n.language)}>
              <button className="button orange-button payment-confirmation-button">
                <img className="img img-fluid" src={downloadButton} alt={downloadButton} />
                {t("paymentConfirmation.button")}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  products: state.product.products,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(Confirm);
